import React, { FC } from 'react';
import cn from 'classnames';
import Image from '@base/lib/ThemeImage';
import site from 'pro/config/site';
import styles from './index.module.less';

const TopBanner: FC<{ largeImage: string, smallImage: string }> = ({ largeImage, smallImage }) => (
    <div className="top-banner">
        <Image
            className="image-large"
            src={largeImage}
            width={1920}
            height={480}
            fixed
        />
        <Image
            className="image-small"
            src={smallImage}
            width={1240}
            height={480}
        />
    </div>
);

const PicText: FC<{ images: string[], width: number, height: number, isRtl?: boolean }> = props => {
    const { images, width, height, isRtl = false, children } = props;
    return (
        <div className={cn('pic-text', { rtl: isRtl })}>
            <div className="col-pic">
                {images.map((item, index) => (
                    <Image
                        className="image"
                        key={index}
                        src={item}
                        width={width}
                        height={height}
                    />
                ))}
            </div>
            <div className="col-text">
                {children}
            </div>
        </div>
    )
};

export default function AboutUs() {
    return (
        <div className={styles['help-about-us']}>
            <TopBanner
                largeImage="asset/width-3840/picture/898aea669281ab90143bec32e7c4a338.jpg"
                smallImage="asset/width-2480/picture/fbb6228619ace5eb91c00372945bfb05.jpg"
            />
            <TopBanner
                largeImage="asset/width-3840/picture/fc5a4252a7903a430923a808d2334be3.jpg"
                smallImage="asset/width-2480/picture/b538083109391ceec78a437b5ce3e6df.jpg"
            />

            <div className="section">
                <div className="announce text-center">
                    You might have noticed that we have made some major changes to our brand. From a website redesign to
                    our new logo, we have been making some major changes to {site.brand} and we want to tell you about it!
                </div>
            </div>

            <div className="section" style={{ background: '#EFEFEF' }}>
                <div className="wrapper">
                    <PicText
                        images={['asset/width-1136/picture/7c596eac80086aa3a7e8739f9a661d8a.png',]}
                        width={568}
                        height={896}
                        isRtl
                    >
                        <h3>Why are we rebranding {site.brand}?</h3>
                        <p>Rebranding is a big challenge that comes with considerations that cannot be taken lightly. As
                            a team, we felt that the previous logo, our socials, and our website needed a new look that
                            better reflected what we value and what we strive for as a company.</p>
                        <p>Our brand is about empowering growers with stylish, reliable products and we wanted to
                            emphasize that. Our rebrand does not make our old products obsolete – they are still the
                            same great products that you know and love and while our new products will have our new
                            branding, the components and construction maintain the same commitment to high quality
                            design, components, craftsmanship, and innovation.</p>
                        <p>We are still in the process of shifting our products into the new style and it is likely that
                            it will take us one to two years to make the full transition so if you receive the &quot;old&quot;
                            brand you are still receiving the same superior quality product.</p>
                    </PicText>
                </div>
            </div>

            <div className="section" style={{ background: '#34302D', color: '#fff' }}>
                <div className="wrapper">
                    <h2 className="points-title">There are three points that have inspired us to progress:</h2>
                    <PicText
                        images={['asset/width-1136/picture/4756cb084d9fbb34dff3d63f4a19ad9d.jpg',]}
                        width={568}
                        height={640}
                    >
                        <div className="number">1</div>
                        <h3>We created an image that better reflects our core values and people.</h3>
                        <p>We are for growers. Our redesign embodies our renewed commitment to creating the best growing
                            products out there and to emphasize our core values as a company. With our new website, new
                            imagery, and overall new engagement strategies we can better fulfill what we believe is most
                            important for our customers.We want to revolutionize indoor growing for everyone and our
                            values define how we interact with the world.</p>
                    </PicText>
                    <div className="points-list">
                        <dl>
                            <dt>Easy</dt>
                            <dd>Develop products that make growing easy and relaxing.</dd>
                        </dl>
                        <dl>
                            <dt>Intelligent</dt>
                            <dd>Build systems and technology that cultivate smarter horticulture.</dd>
                        </dl>
                        <dl>
                            <dt>Empowering</dt>
                            <dd>Help growers reach their fullest potential and thrive.</dd>
                        </dl>
                    </div>
                    <div className="points-list">
                        <dl>
                            <dt>Healthy</dt>
                            <dd>Design low-environmental-impact products that help growers live healthier lives.</dd>
                        </dl>
                        <dl>
                            <dt>Highest Quality</dt>
                            <dd>Build reliable, superior quality products that last.</dd>
                        </dl>
                        <dl>
                            <dt>Inspiring</dt>
                            <dd>Always vibe with the current culture and inspire others.</dd>
                        </dl>
                    </div>
                </div>
            </div>

            <div className="section" style={{ background: '#534D47', color: '#fff' }}>
                <div className="wrapper">
                    <PicText
                        images={[
                            'asset/width-1136/picture/fd3bb43a411fd903692ca8c700030c89.jpg',
                            'asset/width-1136/picture/b2afd97bb132aefc2d0f8712da47929a.jpg',
                            'asset/width-1136/picture/3137e1b31eb3f86a986cc8f0cd6105fd.jpg',
                        ]}
                        width={568}
                        height={322}
                        isRtl
                    >
                        <div className="number">2</div>
                        <h3>We want to establish our own voice by refreshing our style.</h3>
                        <p>We have been in business for over a decade. We have seen a lot of companies come and go, we
                            have seen the industry change dramatically, and we have seen it mature and we have matured
                            right along with it. Part of that means coming into our own brand identity in both terms of
                            imagery and in voice.</p>
                        <p>For us, imagery not only means the style of the products but also the way we communicate with
                            customers, share announcements, advice, and opportunities. It means bringing the community
                            closer to our brand through activities like the Featured Grower profiles, organizing social
                            media groups to share growing tips, and being more engaged in one-on-one conversation. It
                            also means rehauling our language to be more conversational while keeping our
                            professionalism and expertise at the forefront. </p>
                    </PicText>
                </div>
            </div>

            <div className="section" style={{ background: '#34302D', color: '#fff' }}>
                <div className="wrapper">
                    <PicText
                        images={[
                            'asset/width-1136/picture/eff88ff83e3173cc52cc7fd81243ae8e.jpg',
                            'asset/width-1136/picture/891de8e974832eecb4dae8670a29d09d.jpg',
                        ]}
                        width={568}
                        height={372}
                    >
                        <div className="number">3</div>
                        <h3>Our website and materials needed an overhaul.</h3>
                        <p>Lastly, as the industry matured, we recognized we needed to update our website. We want our website to be a hub of not only products but also information and advice that are useful for new and experienced growers alike.</p>
                        <p>{site.brand} is a brand for everyone, regardless of experience level and our new website is designed to be a vast resource that growers can pull from when they need it. We also are proud that it synthesizes well with our social media communities who have been integral at helping us develop our brand and who always provide some of the best advice and support, really making {site.brand} a communal brand.</p>
                    </PicText>
                </div>
            </div>

            <div className="section" style={{ background: '#EFEFEF' }}>
                <div className="wrapper">
                    <PicText
                        images={[
                            'asset/width-1136/picture/08c120ff27abaa694f21c78a26463486.jpg',
                        ]}
                        width={568}
                        height={484}
                        isRtl
                    >
                        <h3>About our new logo</h3>
                        <p>We&apos;re particularly proud of our new logo because it captures exactly what we are striving to develop. The logo balances our three brand pillars: Personal, hydroponic, and technology. We love that the right side of the V represents an LED board while the left side is both a leaf and a droplet of water, encapsulating the elements to growing indoors while giving our brand a fresh look.</p>
                    </PicText>
                </div>
            </div>

            <div className="section" style={{ background: '#fff' }}>
                <div className="wrapper">
                    <PicText
                        images={[
                            'asset/width-1136/picture/362c09d90c66f68a929c73bcdb481795.jpg',
                            'asset/width-1136/picture/b5998fbb7b74a9d2cedbcfbd6c342520.jpg',
                        ]}
                        width={568}
                        height={320}
                    >
                        <h3>TL;DR?</h3>
                        <p>What ISN&apos;T changing:</p>
                        <p>All our products are the same reliable, expert quality equipment that you have come to expect. Whether your product is the &quot;old&quot; style or the &quot;new&quot; one, it is the same superb equipment that you need to love what you grow.</p>
                        <p>&nbsp;</p>
                        <p>What IS changing:</p>
                        <p>We have a new look and a new feel that matches our dedication to our customers and the community at large. We are expanding our grower resources, making it easier to find products and information, and supporting up and coming growers!</p>
                    </PicText>
                </div>
            </div>
        </div>
    )
};
